import colors from 'constants/colors';
import CreateAssignment from 'pages/Support/CreateAssignment';
import OnlineLectures from 'pages/Support/OnlineLectures';
import { FaBookmark } from 'react-icons/fa';

export default [
  {
    collapse: true,
    name: 'Hỗ trợ giảng dạy',
    icon: <FaBookmark style={{ color: colors.font }} />,
    roles: ['teacher'],
    showInSidebar: true,
    sortOrder: 1,
    state: 'lms/support',
    views: [
      {
        path: '/support',
        layout: '/lms',
        exact: true,
        roles: ['authenticated'],
      },
      {
        path: '/support/slides',
        name: 'Bài giảng điện tử',
        miniName: 'D',
        component: OnlineLectures,
        layout: '/lms',
        exact: true,
        roles: ['authenticated'],
        showInSidebar: true,
        sortOrder: 0,
      },
      {
        path: '/support/assignments-management',
        name: 'Quản lý bài tập',
        miniName: 'D',
        component: CreateAssignment,
        layout: '/lms',
        exact: true,
        roles: ['authenticated'],
        showInSidebar: true,
        sortOrder: 1,
      },
    ],
  },
];
